import { ReactNode, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { SnackbarVariant, useSnackbar } from 'hooks/useSnackBar';

export const WhatsAppEntryProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const handledRef = useRef(false);
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    if (handledRef.current) return;

    const params = new URLSearchParams(location.search);
    if (params.get('src') !== 'wa') return;

    handledRef.current = true;
    showSnackbar({ message: 'Opened from WhatsApp', color: 'info' }, SnackbarVariant.ALERT);

    params.delete('src');
    const nextSearch = params.toString();
    const nextURL = `${location.pathname}${nextSearch ? `?${nextSearch}` : ''}${location.hash}`;
    window.history.replaceState(window.history.state, '', nextURL);
  }, [location.hash, location.pathname, location.search, showSnackbar]);

  return <>{children}</>;
};
